import { useState } from 'react';
import { api } from '../../lib/api';
import { LANGUAGES } from '../../i18n';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Sparkles } from 'lucide-react';

export default function AboutTab({ initial, onReload }) {
  const [state, setState] = useState(initial || { translations: {}, contact_email: '', contact_phone: '', contact_address: '' });

  const save = async () => {
    await api.put('/admin/about', state);
    toast.success('About Us saved');
    onReload();
  };

  const translateAll = async () => {
    const src = state.translations?.it;
    if (!src?.title || !src?.mission || !src?.body) { toast.error('Fill IT fields first'); return; }
    toast.info('Translating…');
    const upd = { ...state.translations };
    for (const tgt of LANGUAGES.filter(x => x.code !== 'it')) {
      if (upd[tgt.code]?.title) continue;
      const [t1, t2, t3] = await Promise.all([
        api.post('/admin/translate', { text: src.title, source_lang: 'it', target_lang: tgt.code }),
        api.post('/admin/translate', { text: src.mission, source_lang: 'it', target_lang: tgt.code }),
        api.post('/admin/translate', { text: src.body, source_lang: 'it', target_lang: tgt.code }),
      ]);
      upd[tgt.code] = { title: t1.data.translation, mission: t2.data.translation, body: t3.data.translation };
    }
    setState({ ...state, translations: upd });
    toast.success('Translated');
  };

  const setTr = (langCode, field, value) => {
    setState({
      ...state,
      translations: {
        ...state.translations,
        [langCode]: { ...(state.translations?.[langCode] || {}), [field]: value },
      },
    });
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-serif">About Us</h2>
        <Button onClick={save} data-testid="save-about">Save</Button>
      </div>
      <div className="grid grid-cols-3 gap-4 mb-6">
        <div><Label>Contact Email</Label><Input value={state.contact_email || ''} onChange={e => setState({ ...state, contact_email: e.target.value })} /></div>
        <div><Label>Contact Phone</Label><Input value={state.contact_phone || ''} onChange={e => setState({ ...state, contact_phone: e.target.value })} /></div>
        <div><Label>Address</Label><Input value={state.contact_address || ''} onChange={e => setState({ ...state, contact_address: e.target.value })} /></div>
      </div>
      <div className="space-y-4">
        {LANGUAGES.map(l => (
          <div key={l.code} className="border rounded-sm p-4 space-y-3">
            <div className="flex items-center justify-between">
              <Label className="text-xs uppercase tracking-widest">{l.flag} {l.label}</Label>
              {l.code === 'it' && (
                <Button variant="ghost" size="sm" onClick={translateAll}>
                  <Sparkles className="w-4 h-4 mr-1" /> Translate all
                </Button>
              )}
            </div>
            <Input placeholder="Title" value={state.translations?.[l.code]?.title || ''} onChange={e => setTr(l.code, 'title', e.target.value)} />
            <Input placeholder="Mission" value={state.translations?.[l.code]?.mission || ''} onChange={e => setTr(l.code, 'mission', e.target.value)} />
            <Textarea placeholder="Body" rows={3} value={state.translations?.[l.code]?.body || ''} onChange={e => setTr(l.code, 'body', e.target.value)} />
          </div>
        ))}
      </div>
    </div>
  );
}
